import React from 'react'

import { useSelectedCurrency } from '../hooks/useSelectedCurrency'

import { MeasurLocale, formatPriceRange, formatPriceWithCurrency } from './i18n'

export const PriceWithCurrency = ({
  price,
  locale,
}: {
  price: number
  locale: MeasurLocale
}) => {
  const { currency } = useSelectedCurrency()

  return <span>{formatPriceWithCurrency(price, locale, currency)}</span>
}

export const PriceRangeWithCurrency = ({
  priceRange,
  locale,
}: {
  priceRange: [number, number]
  locale: MeasurLocale
}) => {
  const { currency } = useSelectedCurrency()
  return <span>{formatPriceRange(priceRange, locale, currency)}</span>
}
